var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExitButton = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.728,
    height: 17.7,
    viewBox: "0 0 23.728 17.7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-286.137 -411.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.864,427.284V413.712a2.064,2.064,0,0,0-2.061-2.062H295.738a2.064,2.064,0,0,0-2.061,2.062v3.016a.553.553,0,1,0,1.107,0v-3.016a.955.955,0,0,1,.954-.954H307.8a.955.955,0,0,1,.954.954v13.572a.954.954,0,0,1-.954.954H295.738a.954.954,0,0,1-.954-.954v-3.016a.554.554,0,0,0-.554-.553h0a.551.551,0,0,0-.552.553v3.016a2.065,2.065,0,0,0,2.061,2.066H307.8A2.064,2.064,0,0,0,309.864,427.284Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.325,420.5a.554.554,0,0,0-.554-.554H288.028l3.579-3.578a.565.565,0,0,0,.174-.414.557.557,0,0,0-.555-.544h-.011a.553.553,0,0,0-.39.171l-4.526,4.526a.558.558,0,0,0,0,.786h0l4.524,4.523a.566.566,0,0,0,.785,0,.555.555,0,0,0,0-.784l-3.58-3.578h13.743A.554.554,0,0,0,302.325,420.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExitButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exit-button.d29eedf7.svg";
export { ForwardRef as ReactComponent };